import apiService from './api.service';
import ModeService from './mode.service';

// User service for managing user-related APIs
const UserService = (() => {
  let currentUser: any = null;
  let headerShown = false;
  let firstTimeLoading = true;

  return {
    login: async (phone: any) => {
      const data = { mobile: phone };
      try {
        const response = await (await apiService).post('/login', data);
        currentUser = response.user;
        return response;
      } catch (error) {
        throw error;
      }
    },

    verifyOtp: async (phone: any, otp: any) => {
      const data = {
        mobile: phone,
        otp: otp,
        fcm_token: "", // Replace with actual token if you're using web push
      };

      try {
        const response = await (await apiService).post('/otp-verification', data);
        currentUser = response.user;
        return response;
      } catch (error) {
        throw error;
      }
    },

    getAuthedUser: async () => {
      try {
        const response = await (await apiService).get('/user-resolver');
        return response;
      } catch (error) {
        throw error;
      }
    },

    getJobTypes: async () => {
      try {
        const response = await (await apiService).get('/job-types');
        return response;
      } catch (error) {
        throw error;
      }
    },

    updateProfile: async (data: any) => {
      try {
        const response = await (await apiService).post('/profile', data);
        return response;
      } catch (error) {
        throw error;
      }
    },

    updateJobTypes: async (data: any) => {
      try {
        const response = await (await apiService).post('/update-job-types', data);
        return response;
      } catch (error) {
        throw error;
      }
    },

    updateLocation: async (data: any) => {
      try {
        const response = await (await apiService).post('/update-location', data);
        return response;
      } catch (error) {
        throw error;
      }
    },

    getCurrentUser: () => currentUser,

    setCurrentUser: (user: any) => {
      currentUser = user;
    },

    logout: () => {
      localStorage.removeItem("api_token");
      localStorage.removeItem("mode");
      UserService.setHeaderShown(false);
      UserService.setCurrentUser(null);
      ModeService.setMode('');
    },

    getHeaderShown: () => headerShown,

    setHeaderShown: (res: any) => {
      headerShown = res;
    },

    getFirstTimeLoading: () => firstTimeLoading,

    setFirstTimeLoading: (res: any) => {
      firstTimeLoading = res;
    }
  };
})();

export default UserService;
